module.exports = __webpack_public_path__ + "static/media/logo-커넥트히어로@3x.d8d2207e.png";